import { render, staticRenderFns } from "./ActiveFilters.vue?vue&type=template&id=64cbe020&scoped=true"
import script from "./ActiveFilters.vue?vue&type=script&lang=js"
export * from "./ActiveFilters.vue?vue&type=script&lang=js"
import style0 from "./ActiveFilters.vue?vue&type=style&index=0&id=64cbe020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cbe020",
  null
  
)

export default component.exports